module.exports = dependencies['react-dom']['16.13.1']['module'];